import React, { useContext } from 'react'
import MyImage from '@shared/components/myImage'
import styles from '@shared/components/Advertisement/Advertise.module.scss'
import betting1 from '@assets/images/Advertisement/betting1.png'
import betting2 from '@assets/images/Advertisement/betting2.png'
import betting3 from '@assets/images/Advertisement/betting3.png'
import partner1 from '@assets/images/Advertisement/darkModeImages/partner1.png'
import partner2 from '@assets/images/Advertisement/darkModeImages/partner2.png'
import partner3 from '@assets/images/Advertisement/darkModeImages/partner3.png'
import GlobalEventsContext from '@shared/components/global-events/GlobalEventsContext'

const FantasyPartner = () => {
  const { stateGlobalEvents } = useContext(GlobalEventsContext)
  return (
    <div className={`text-center px-6 pb-4 ${styles.fantasyContainer}`}>
      <h2
        className={`h2  sm:py-0 font-bold ${styles.bettingH1}`}>
        For Fantasy Partners
      </h2>
      <div
        className={`d-none d-sm-flex flex-column align-items-center justify-content-around px-6 py-61 ${styles.bettingContainer}`}
        style={{
          marginLeft: '50px',
          marginRight: '50px',
          borderRadius: '16px'
        }}>
        <div className="d-flex flex-wrap justify-content-center  pt-4 mx-3 gap-5 w-100">
          <MyImage src={stateGlobalEvents?.darkModeEna === 'dark' ? partner1 : betting1} alt="Betting 1" width={384} height={350} className={`w-75 ${styles.fantasysImages}`} />

          <MyImage src={stateGlobalEvents?.darkModeEna === 'dark' ? partner2 : betting2} alt="Betting 2" width={272} height={350} className={`w-75 ${styles.fantasysImages}`}
          style ={{
            marginBottom: '-10px'
          }}/>

          <MyImage src={stateGlobalEvents?.darkModeEna === 'dark' ? partner3 : betting3} alt="Betting 3" width={384} height={350} className={`w-75 ${styles.fantasysImages}`} />
        </div>
        <div
          className={`w-100 d-flex flex-wrap justify-content-evenly text-xl  p-4 ${styles.bettingTextBox}`}
          style={{
            height: '97px',
            borderBottomLeftRadius: '16px',
            borderBottomRightRadius: '16px',
            fontSize: '24px',
            fontWeight: '600'
          }}>
          <span className="rounded-lg text-center py-2 px-4 ">Sponsored Tags</span>
          <span className="rounded-lg text-center py-2 px-4">App Banners</span>
          <span className="rounded-lg text-center py-2 px-4">Social Media Posts</span>
        </div>
      </div>

      <div className="d-flex flex-column gap-3 d-sm-none mx-4">
        <div>
          <div className={`d-flex flex-column align-items-center justify-content-center  pt-4 w-100 ${styles.borderRad}`}>
            <MyImage src={stateGlobalEvents?.darkModeEna === 'dark' ? partner1 : betting1} loadOnScroll alt="Betting 1" className={`w-75 ${styles.smImage}`} />
          </div>
          <div className={`text-center py-4 px-4 ${styles.lowerContainer}`}>Sponsored Tags</div>
        </div>
        <div>
          <div className={`d-flex flex-column align-items-center justify-content-center pt-4 w-100 ${styles.borderRad}`}>
            <MyImage src={stateGlobalEvents?.darkModeEna === 'dark' ? partner2 : betting2} loadOnScroll alt="Betting 2" className={`w-75 ${styles.smImage}`} />
          </div>
          <div className={` text-center py-4 px-4 ${styles.lowerContainer}`}>App Banners</div>
        </div>
        <div>
          <div className={`d-flex flex-column align-items-center justify-content-center pt-4 w-100 ${styles.borderRad}`}>
            <MyImage src={stateGlobalEvents?.darkModeEna === 'dark' ? partner3 : betting3} loadOnScroll alt="Betting 3" className={`w-75 ${styles.smImage}`} />
          </div>
          <div className={`text-center py-4 px-4 ${styles.lowerContainer}`}>Social Media Posts</div>
        </div>
      </div>
    </div>
  )
}
export default FantasyPartner
